import { PortalHost } from "@gorhom/portal";
import React, { FC, ReactNode } from "react";
import { StatusBar } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { theme } from "@lookiero/sty-psp-ui";

interface AppProps {
  readonly children: ReactNode;
}

const App: FC<AppProps> = ({ children }) => {
  const { colorBgBase } = theme();

  return (
    <SafeAreaProvider>
      <StatusBar backgroundColor={colorBgBase} barStyle="dark-content" translucent />
      <PortalHost name="LookIn" />
      {children}
    </SafeAreaProvider>
  );
};

export { App };
